// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-page-forgot-password h1 {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/forgotPassword/ForgotPassword.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ","sourcesContent":[".lsn-page-forgot-password {\n  h1 {\n    margin-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
